





























import { Component, Watch } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import SubTransactionType from '@/models/Products/SubTransactionTypes/SubTransactionType';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import CreateSubTransactionType from '@/components/Products/SubTransactionTypes/CreateSubTransactionType.vue';

@Component({ name: 'SubTransactionTypesList', components: { Alert, CreateSubTransactionType }, metaInfo: { title: 'Sub Transaction Types' } })
export default class extends SaascadaVue {

    search = '';
    // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
    headers = [
        { text: this.$t('pageText.subTransactionTypes.fields.code'), value: 'code', sortable: false, width: '40%' },
        { text: this.$t('pageText.subTransactionTypes.fields.description'), value: 'description', sortable: false, width: '60%' }
    ];
    subTransactionTypesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.subTransactionTypesPage = +page;
        }
    }

    async beforeMount() {
        await SubTransactionTypesModule.getSubTransactionTypes();
    }

    get subTransactionTypes() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get totalSubTransactionTypesPages() {
        return SubTransactionTypesModule.totalSubTransactionTypesPages;
    }

    get loading() {
        return SubTransactionTypesModule.loading;
    }

    get pageSize() {
        return SubTransactionTypesModule.pageSize;
    }

    @Watch('subTransactionTypesPage')
    async onSubTransactionTypesPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.subTransactionTypesPage}` } });
    }


    async navigateToSubTransactionType(subTransactionType: SubTransactionType) {
        this.$router.push({ name: PageNames.SubTransactionType, params: { id: subTransactionType.id }, query: { tab: "0" } });
    }

}
